import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class PlaguedForest3PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.PLAGUED_FOREST3;
}

export default PlaguedForest3PoiTileEntity;
